import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {inject, observer} from 'mobx-react'

import ChartCanvas from 'Components/_charts/ChartCanvas'
import {CrossHairCursor} from 'react-stockcharts/lib/coordinates'

import {discontinuousTimeScaleProvider} from 'react-stockcharts/lib/scale'

import {fitWidth} from 'react-stockcharts/lib/helper'
import {last} from 'react-stockcharts/lib/utils'

import {Candlestick} from './Candlestick'
import {Volume} from './Volume'
import {Indicators} from './Indicators'

@inject('store') @observer
class Chart extends Component {
  componentDidMount() {
    const xExtents = this.getXExtents()
    const originalExtents = {xExtents}
    this.props.changeState({xExtents, originalExtents})
  }
  getXExtents = () => {
    const {data: initialData} = this.props

    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(d =>
      new Date(new Date(d.date).getTime() + new Date(d.date).getTimezoneOffset()*60000 - 4*60*60000)
    )

    const {
      data,
      xAccessor,
    } = xScaleProvider(initialData)

    const right = xAccessor(last(data))
    const left = xAccessor(data[0])
    return([left, right])
  }
  handleBrush = ({start, end}) => {
    const left = Math.min(start.xValue, end.xValue)
    const right = Math.max(start.xValue, end.xValue)

    if ((right - left) < 3) {
      this.props.changeState({
        brushEnabled: false
      })
      return
    }

    this.props.changeState({
      xExtents: [left, right],
      brushEnabled: false
    })
  }

  render() {
    const {type, data:initialData, width, ratio, indicators, showModal, compare, xExtents, suffix, brushEnabled} = this.props
    const {analysis} = this.props.store
    if (!xExtents || xExtents[1] > initialData.length) {
      return null
    }
    let separateIndicators = []
    let candlestickIndicators = []

    indicators.map(ind => {
      if (ind.separate) {
        separateIndicators.push(ind)
      } else {
        candlestickIndicators.push(ind)
      }
    })

    const xScaleProvider = discontinuousTimeScaleProvider.inputDateAccessor(d =>
      new Date(new Date(d.date).getTime() + new Date(d.date).getTimezoneOffset()*60000 - 4*60*60000)
    )

    const {
      data,
      xScale,
      xAccessor,
      displayXAccessor,
    } = xScaleProvider(initialData)

    let margin = { left: 55, right: 60, top: 68, bottom: 20 }
    const gridWidth = width - margin.left - margin.right

    const tooltipRowSize = Math.floor(gridWidth/320)
    let tooltipRows = Math.ceil(candlestickIndicators.length/tooltipRowSize)
    if (/*bb && */candlestickIndicators.length%tooltipRowSize !== 1) {
      tooltipRows++
    }

    margin.top += 35*tooltipRows

    const candlestickHeight = 308
    const indicatorHeight = 135
    const indicatorSpacing = 80
    const topIndicatorMargin = 25
    const canvasHeight = margin.top + margin.bottom + candlestickHeight + (indicatorHeight + indicatorSpacing) * separateIndicators.length + (topIndicatorMargin)

    // const buttonOffset = -margin.left + 6*102 + 98

    let separators = []

    for (let i=1; i<=separateIndicators.length; i++) {
      const offset = margin.top + candlestickHeight + topIndicatorMargin + (indicatorHeight + indicatorSpacing) * i - indicatorSpacing/4
      const style = {
        width: '100vw',
        border: 'none',
        margin: '20px 0 0 0',
        height: '1px',
        background: 'rgb(205, 205, 205)',
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        top: offset
      }
      separators.push(
        <hr key={i} style={style}/>
      )
    }
    return(
      <div>
        {separators}
        {/* Just commented for now in case to revamp in the next release */}
        {/* <button
          style={{
            position: 'absolute',
            left: buttonOffset,
            top: 19
          }}
          onClick={reset}
        >
          <span>Reset</span>
          <i/>
        </button> */}
        <ChartCanvas
          seriesName={`analysis-${suffix}`}
          height={canvasHeight}
          ratio={ratio}
          width={width}
          margin={margin}
          type={type}
          panEvent={true}
          zoomEvent={false}
          data={data}
          xScale={xScale}
          xAccessor={xAccessor}
          displayXAccessor={displayXAccessor}
          xExtents={xExtents}
          clamp={true}
        >
          {Candlestick({
            gridWidth,
            indicators: candlestickIndicators,
            compare,
            showModal,
            marginTop: margin.top,
            frequency: analysis.bar_size,
            brushEnabled,
            handleBrush: this.handleBrush
          })}
          {Volume({
            brushEnabled,
            handleBrush: this.handleBrush
          })}
          {Indicators({
            indicators: separateIndicators,
            showModal,
            gridWidth,
            marginTop: margin.top,
            brushEnabled,
            handleBrush: this.handleBrush
          })}
          <CrossHairCursor origin={[0,20]}/>
        </ChartCanvas>
      </div>
    )
  }
}

Chart.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  ratio: PropTypes.number.isRequired,
  type: PropTypes.oneOf(['svg', 'hybrid']).isRequired,
}

Chart.defaultProps = {
  type: 'svg',
}
Chart = fitWidth(Chart)

export default Chart
